(function() {
  if (window.__wkPdp) return;
  window.__wkPdp = true;

  if (!document.documentElement.classList.contains('wk-pdp-on')) return;

  const config = document.getElementById('wk-pdp-config');
  const cfg = (config && config.dataset) || {};
  const tintEnabled = cfg.tint === 'true';
  const thumbsEnabled = cfg.thumbs === 'true';
  const stickyBarEnabled = cfg.stickyBar === 'true';

  const wrap = document.querySelector('[id^="MainProduct-"]');
  const product = wrap && wrap.querySelector(':scope > .product');
  if (!wrap || !product) return;
  const info = product.querySelector('[id^="ProductInfo-"]');

  // Ordenador = 990 px o más (el mismo corte que la sección)
  const mq = window.matchMedia('(min-width: 990px)');
  function alCambiarAncho(fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }
  // Nombre del archivo de una foto, sin carpeta ni tamaño (para reconocer la misma foto servida en otro tamaño)
  function nombreFoto(src) {
    try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()).toLowerCase(); } catch (e) { return ''; }
  }

  // Selectores de variante: el de color es el que tiene muestras pintadas; el otro, la talla
  const radios = product.querySelector('variant-radios');
  const grupos = radios ? Array.from(radios.querySelectorAll('fieldset.product-form__input')) : [];
  const fsColor = grupos.find(fs => fs.querySelector('label.swatch-color')) || null;
  const fsTalla = grupos.find(fs => fs !== fsColor) || null;
  function opciones(fs) { return fs ? Array.from(fs.querySelectorAll('input[type="radio"]')) : []; }
  function elegida(fs) { const i = fs && fs.querySelector('input[type="radio"]:checked'); return i ? i.value : ''; }

  // Migas encima del título (dentro de .product__title, así salen también en el móvil).
  // El artista ya no sale bajo el título (15/10): solo en Detalles, dentro de la descripción.
  try {
    const titulo = product.querySelector('.product__title');
    const h1 = titulo && titulo.querySelector('h1');
    if (titulo && h1) {
      // Migas: el apartado principal del menú de la cabecera (Camisetas, Sudaderas...) que lleva a una
      // colección del producto, directamente o por uno de sus submenús. Sin los apartados de promoción.
      const cols = (cfg.cols || '').split(',').filter(Boolean);
      const promo = /best|novedad|new-in|outlet|last|rebaja|sale|promo|black/i;
      const coleccion = a => ((a && a.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/) || [])[1];
      // Sin los enlaces de campaña (Semana Eden: "Promoción Eden" lleva a Camisetas y si no, las migas dirían "Promoción Eden")
      const principales = Array.from(document.querySelectorAll('nav.header__inline-menu > ul > li > a, nav.header__inline-menu > ul > li summary > a'))
        .filter(a => coleccion(a) && !promo.test(coleccion(a)) && a.textContent.trim() && !a.closest('[data-wke]'));
      const enlace = !cols.length ? null :
        principales.find(a => cols.indexOf(coleccion(a)) > -1) ||
        principales.find(a => {
          const sub = a.closest('details');
          return sub && Array.from(sub.querySelectorAll('a[href*="/collections/"]')).some(s => cols.indexOf(coleccion(s)) > -1);
        }) || null;
      if (enlace) {
        const migas = document.createElement('nav');
        migas.className = 'wk-migas';
        const a = document.createElement('a');
        a.href = enlace.getAttribute('href');
        a.textContent = enlace.textContent.trim().replace(/\s+/g, ' ');
        const sep = document.createElement('span');
        sep.className = 'wk-migas__sep';
        sep.textContent = '/';
        const actual = document.createElement('span');
        actual.textContent = h1.textContent.trim();
        migas.append(a, sep, actual);
        titulo.insertBefore(migas, titulo.firstChild);
        // En el móvil las migas van encima de las fotos; en el ordenador, encima del título
        const fotos = product.querySelector('.product__media-wrapper');
        const ponMigas = function (pc) {
          if (pc) titulo.insertBefore(migas, titulo.firstChild);
          else if (fotos) fotos.parentNode.insertBefore(migas, fotos);
        };
        ponMigas(mq.matches);
        alCambiarAncho(e => ponMigas(e.matches));
      }
    }
  } catch (e) {}

  // Selector de formatos adultos del mismo diseño. La búsqueda solo sirve para descubrir
  // productos publicados; la identidad y la clasificación se validan aquí con metadata exacta.
  try {
    const formatoActual = { designId: (cfg.designId || '').trim(), designName: (cfg.designName || '').trim(), familyId: (cfg.familyId || '').trim(), sectionId: (cfg.sectionId || '').trim(), handle: (cfg.handle || '').trim() };
    const formatos = {
      '04/47': ['regular', cfg.tRegular || 'Regular'],
      '04/71': ['oversize', cfg.tOversize || 'Oversize'],
      '04/75': ['cropped', cfg.tCropped || 'Cropped'],
      '10/45': ['sin-capucha', cfg.tSinCapucha || 'Without hood'],
      '10/46': ['con-capucha', cfg.tConCapucha || 'With hood'],
      // Niño (15/10): camiseta y sudadera del mismo diseño
      '04/25': ['nino-camiseta', cfg.tNinoCamiseta || 'T-shirt'],
      '10/25': ['nino-sudadera', cfg.tNinoSudadera || 'Sweatshirt']
    };
    const etiquetasFormato = Object.keys(formatos).reduce((out, code) => { out[formatos[code][0]] = formatos[code][1]; return out; }, {});
    // Los de niño comparten diseño con los de adulto: cada ficha solo enlaza con los de su grupo (adulto o niño)
    const grupo = f => f && /^nino-/.test(f[0]) ? 'nino' : 'adulto';
    const formatoPropio = formatos[formatoActual.familyId + '/' + formatoActual.sectionId] || null;
    const tipoFormato = p => {
      if (!p || (p.design_id || '').trim() !== formatoActual.designId) return null;
      const key = (p.family_id || '').trim() + '/' + (p.section_id || '').trim();
      const f = formatos[key] || null;
      return f && formatoPropio && grupo(f) === grupo(formatoPropio) ? f : null;
    };
    const urlValida = raw => {
      try {
        const u = new URL(raw, location.href);
        return u.origin === location.origin && u.pathname.replace(/\/+$/, '') === (new URL(cfg.searchUrl || '/search', location.href)).pathname.replace(/\/+$/, '') && u.searchParams.get('view') === 'wk-formatos' ? u : null;
      } catch (e) { return null; }
    };
    const montarFormato = async () => {
      if (!config || !info || !formatoActual.designId || !formatoActual.designName || !formatoActual.familyId || !formatoActual.sectionId || !cfg.searchUrl) return;
      if (!tipoFormato({ design_id: formatoActual.designId, family_id: formatoActual.familyId, section_id: formatoActual.sectionId })) return;
      const base = new URL(cfg.searchUrl, location.href);
      if (base.origin !== location.origin) return;
      base.searchParams.set('q', formatoActual.designName);
      base.searchParams.set('type', 'product');
      base.searchParams.set('view', 'wk-formatos');
      base.searchParams.set('options[unavailable]', 'last');
      const preview = new URL(location.href).searchParams.get('preview_theme_id') || '';
      if (preview) base.searchParams.set('preview_theme_id', preview);
      const encontrados = [];
      const vistos = new Set();
      let siguiente = base.href;
      const paginas = new Set();
      for (let pagina = 0; pagina < 8 && siguiente; pagina += 1) {
        const u = urlValida(siguiente);
        if (!u) throw new Error('wk-formatos: URL inválida');
        if (paginas.has(u.href)) throw new Error('wk-formatos: paginación circular');
        paginas.add(u.href);
        const res = await fetch(u.href, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('wk-formatos: HTTP ' + res.status);
        const datos = await res.json();
        if (!Array.isArray(datos.results)) throw new Error('wk-formatos: JSON inválido');
        datos.results.forEach(p => {
          const h = typeof p.handle === 'string' ? p.handle.trim() : '';
          if (h && !vistos.has(h)) { vistos.add(h); encontrados.push(p); }
        });
        if (datos.next_url) {
          const next = urlValida(datos.next_url);
          if (!next) throw new Error('wk-formatos: next_url inválida');
          next.searchParams.set('q', formatoActual.designName);
          next.searchParams.set('type', 'product');
          next.searchParams.set('view', 'wk-formatos');
          next.searchParams.set('options[unavailable]', 'last');
          if (preview) next.searchParams.set('preview_theme_id', preview);
          siguiente = next.href;
        } else siguiente = '';
      }
      if (siguiente) throw new Error('wk-formatos: límite de páginas');
      const porFormato = new Map();
      encontrados.forEach(p => { const f = tipoFormato(p); if (f) { if (!porFormato.has(f[0])) porFormato.set(f[0], []); porFormato.get(f[0]).push(p); } });
      if (formatoActual.handle && !encontrados.some(p => p.handle === formatoActual.handle)) {
        const f = tipoFormato({ design_id: formatoActual.designId, family_id: formatoActual.familyId, section_id: formatoActual.sectionId });
        if (f) { if (!porFormato.has(f[0])) porFormato.set(f[0], []); porFormato.get(f[0]).push({ handle: formatoActual.handle, url: base.pathname.replace(/\/search\/?$/, '/products/') + encodeURIComponent(formatoActual.handle), available: true, design_id: formatoActual.designId, family_id: formatoActual.familyId, section_id: formatoActual.sectionId }); }
      }
      if (porFormato.size < 2) return;
      // Pastilla de cristal arriba de la foto (como "3 camisetas por 39€"), como un interruptor: con el ratón encima
      // no cambia nada; al pulsar un formato, el negro pasa a ese formato y se abre su ficha.
      const medios = product.querySelector('.product__media-wrapper');
      if (!medios) return;
      const caja = document.createElement('nav');
      caja.className = 'wk-formatos';
      caja.setAttribute('aria-label', cfg.tFormato || 'Format');
      // Primera foto de cada formato (la usa la rueda del móvil), solo si viene de la propia tienda o de Shopify
      const fotoValida = raw => {
        try {
          const u = new URL(raw, location.href);
          return u.protocol === 'https:' && (u.hostname === location.hostname || u.hostname === 'cdn.shopify.com') ? u.href : '';
        } catch (e) { return ''; }
      };
      const orden = ['regular', 'oversize', 'cropped', 'sin-capucha', 'con-capucha', 'nino-camiseta', 'nino-sudadera'];
      Array.from(porFormato.keys()).sort((a, b) => orden.indexOf(a) - orden.indexOf(b)).forEach(key => {
        const lista = porFormato.get(key).slice().sort((a, b) => ((a.handle || '').localeCompare(b.handle || '')));
        const elegido = lista.find(p => p.handle === formatoActual.handle) || lista.find(p => p.available) || lista[0];
        if (!elegido || !elegido.url || !elegido.handle) return;
        const destino = new URL(elegido.url, location.href);
        const rutaProducto = base.pathname.replace(/\/search\/?$/, '/products/') + encodeURIComponent(elegido.handle);
        if (destino.origin !== location.origin || destino.pathname !== rutaProducto) return;
        const a = document.createElement('a');
        a.textContent = etiquetasFormato[key];
        a.href = elegido.url;
        if (preview) { const link = new URL(a.href, location.href); link.searchParams.set('preview_theme_id', preview); a.href = link.href; }
        const actual = elegido.handle === formatoActual.handle;
        if (actual) { a.setAttribute('aria-current', 'page'); a.className = 'is-active'; }
        const foto = elegido.image ? fotoValida(elegido.image) : '';
        if (foto) a.dataset.wkFoto = foto;
        // Todas las fotos del formato: la rueda busca entre ellas una del mismo tipo que la que se está viendo
        a.__fotos = (Array.isArray(elegido.images) ? elegido.images : []).map(fotoValida).filter(Boolean);
        if (!a.__fotos.length && foto) a.__fotos = [foto];
        a.addEventListener('click', e => {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          if (actual) { e.preventDefault(); return; }
          caja.querySelectorAll('a').forEach(x => x.classList.toggle('is-active', x === a));
        });
        caja.appendChild(a);
      });
      if (caja.querySelectorAll('a').length < 2) return;
      medios.appendChild(caja);
      montaRueda(medios, Array.from(caja.querySelectorAll('a')));
    };
    // Rueda de cristal arriba a la derecha de la foto (móvil: 44 px y 130 px mientras se pulsa; ordenador, desde el 15/10: 70 px y
    // 130 px con el ratón encima, y además se puede pulsar un nombre), con los nombres en curva por el borde; el de
    // arriba, bajo el triángulo, es el elegido. Se gira con el dedo y, mientras gira, la foto grande enseña una del formato
    // que queda arriba parecida a la que se ve (modelo por modelo, prenda por prenda...; en el ordenador, desde el 15/10, cambia toda la
    // columna: ver ponVista); al soltar en otro formato se abre su ficha (en el mismo, vuelve la foto de siempre) y un toque
    // corto pasa al siguiente. La pastilla se oculta a la vista pero sigue para los lectores de pantalla (wk-pdp.css).
    const montaRueda = (medios, enlaces) => {
      const n = enlaces.length;
      const paso = 360 / n;
      const tam = 70, mitad = tam / 2, rad = mitad - 11;
      const largo = 2 * Math.PI * rad;
      const ns = 'http://www.w3.org/2000/svg';
      const rueda = document.createElement('div');
      rueda.className = 'wk-rueda';
      rueda.setAttribute('aria-hidden', 'true');
      const svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + tam + ' ' + tam);
      // El camino da dos vueltas desde abajo: así ningún nombre cae en el corte del círculo
      const vuelta = 'a' + rad + ',' + rad + ' 0 1,1 0,-' + (2 * rad) + ' a' + rad + ',' + rad + ' 0 1,1 0,' + (2 * rad);
      const defs = document.createElementNS(ns, 'defs');
      const camino = document.createElementNS(ns, 'path');
      camino.setAttribute('id', 'wk-rueda-camino');
      camino.setAttribute('d', 'M' + mitad + ',' + (mitad + rad) + ' ' + vuelta + ' ' + vuelta);
      defs.appendChild(camino);
      const anillo = document.createElementNS(ns, 'g');
      svg.append(defs, anillo);
      const textos = enlaces.map((a, i) => {
        const t = document.createElementNS(ns, 'text');
        const tp = document.createElementNS(ns, 'textPath');
        tp.setAttribute('href', '#wk-rueda-camino');
        tp.setAttribute('startOffset', ((0.5 + i / n) * 50) + '%');
        tp.setAttribute('text-anchor', 'middle');
        tp.textContent = a.textContent.trim().toUpperCase();
        t.appendChild(tp);
        anillo.appendChild(t);
        return t;
      });
      const tri = document.createElement('span');
      tri.className = 'wk-rueda__tri';
      const centro = document.createElement('span');
      centro.className = 'wk-rueda__centro';
      rueda.append(svg, tri, centro);
      medios.appendChild(rueda);
      // Nombres largos (otros idiomas): se aprietan para que quepan en su trozo de borde (cuando la rueda se ve).
      // 16/10: Safari (iPhone y Mac) centra un nombre apretado con su largo sin apretar (CON CAPUCHA pisaba a CROPPED)
      // y al medir no cuenta el espacio entre letras. Se mide sin ese espacio y se le suma, y el nombre apretado se
      // dibuja desde su principio, calculado aquí, en lugar de centrarlo el navegador. Se repite al cargar la letra.
      const hueco = largo / n - 6;
      const ajusta = () => {
        if (!rueda.offsetWidth) return;
        textos.forEach((t, i) => {
          const tp = t.firstChild;
          tp.removeAttribute('textLength');
          tp.removeAttribute('lengthAdjust');
          const espacio = parseFloat(getComputedStyle(t).letterSpacing) || 0;
          t.style.letterSpacing = '0px';
          const natural = t.getComputedTextLength() + espacio * tp.textContent.length;
          t.style.letterSpacing = '';
          if (natural > hueco) {
            tp.setAttribute('textLength', hueco);
            tp.setAttribute('lengthAdjust', 'spacingAndGlyphs');
            tp.setAttribute('text-anchor', 'start');
            // En % del camino, como los centrados: cada navegador mide el círculo a su manera (Chrome, algo más corto)
            tp.setAttribute('startOffset', ((0.5 + i / n) * 50 - hueco / largo * 25) + '%');
          } else {
            tp.setAttribute('text-anchor', 'middle');
            tp.setAttribute('startOffset', ((0.5 + i / n) * 50) + '%');
          }
        });
      };
      new ResizeObserver(ajusta).observe(rueda);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajusta);
      const activa = Math.max(0, enlaces.findIndex(a => a.classList.contains('is-active')));
      let pos = activa;
      // Foto grande que se ve ahora (la del carrusel); se cambia por la del formato de arriba y se recupera al volver
      const fotoGrande = () => {
        let mejor = null, area = 0;
        medios.querySelectorAll('img').forEach(img => {
          if (img.closest('.wk-thumbs, .wk-formatos, .wk-rueda, .wk-vista')) return;
          const r = img.getBoundingClientRect();
          const w = Math.min(r.right, innerWidth) - Math.max(r.left, 0);
          const h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
          if (w > 0 && h > 0 && w * h > area) { area = w * h; mejor = img; }
        });
        return area > 40000 ? mejor : null;
      };
      // Tipo de cada foto por su nombre y, si no dice nada, por su puesto: las dos primeras son la prenda sola y las del
      // medio, de modelo. Además, el lado (delantera o trasera) y la persona (chica o chico) cuando el nombre lo dice.
      const fichas = lista => {
        const cuenta = {};
        return lista.map((src, i) => {
          const f = nombreFoto(src);
          const t = /detall|detail/.test(f) ? 'detalle' : /model|chic[ao]/.test(f) ? 'modelo' : /final/.test(f) ? 'dibujo'
            : (/camiseta|sudadera/.test(f) || i < 2) ? 'prenda' : 'modelo';
          cuenta[t] = (cuenta[t] || 0) + 1;
          return { src, f, t, k: cuenta[t] - 1, lado: /delan|dealn/.test(f) ? 'd' : /traser/.test(f) ? 't' : '', quien: /chica/.test(f) ? 'a' : /chico/.test(f) ? 'o' : '' };
        });
      };
      const propias = fichas(Array.from(medios.querySelectorAll('.product__media-list > li.product__media-item img')).map(img => img.currentSrc || img.src));
      // Foto del otro formato parecida a la que se ve: del mismo tipo y, si los nombres lo dicen, del mismo lado y la misma
      // persona; si no, la del mismo puesto entre las de su tipo. Si no tiene ninguna de ese tipo, su primera foto.
      const pareja = (vista, lista) => {
        const otras = fichas(lista || []);
        if (!otras.length) return '';
        const yo = propias.find(x => x.f === nombreFoto(vista));
        let mejor = null, nota = -Infinity;
        if (yo) otras.forEach(x => {
          if (x.t !== yo.t) return;
          let n = -Math.abs(x.k - yo.k);
          if (yo.lado && x.lado) n += x.lado === yo.lado ? 20 : -20;
          if (yo.quien && x.quien) n += x.quien === yo.quien ? 10 : -10;
          if (n > nota) { nota = n; mejor = x; }
        });
        return (mejor || otras[0]).src;
      };
      let cambiada = null, enFoto = activa;
      const devuelveFoto = () => {
        enFoto = activa;
        if (!cambiada) return;
        cambiada.src = cambiada.dataset.wkFmtSrc;
        if (cambiada.dataset.wkFmtSet) cambiada.setAttribute('srcset', cambiada.dataset.wkFmtSet);
        cambiada = null;
      };
      // Ordenador (15/10): al girar, la columna enseña todas las fotos del formato de arriba, en su orden y con sus
      // miniaturas, y a la vista queda la parecida a la que se estaba viendo; al volver al formato propio vuelve todo.
      // Es una capa encima de la galería, que no se toca (solo se esconde mientras se ve la capa)
      const galeria = medios.querySelector('media-gallery .product__media-list');
      const conAncho = (src, w) => { try { const u = new URL(src, location.href); u.searchParams.set('width', w); return u.href; } catch (e) { return src; } };
      // Fotos de la prenda sobre blanco: enteras, como las marca la galería (wk-plana)
      const plana = img => {
        try {
          const c = document.createElement('canvas');
          c.width = c.height = 16;
          const x = c.getContext('2d');
          x.drawImage(img, 0, 0, 16, 16);
          const d = x.getImageData(0, 0, 16, 16).data;
          if ([0, 60, 960, 1020].every(k => d[k] >= 240 && d[k + 1] >= 240 && d[k + 2] >= 240)) img.classList.add('wk-plana');
        } catch (e) {}
      };
      const vistas = new Map();
      let vista = null, base = '', baseArriba = 0;
      const montaVista = i => {
        if (vistas.has(i)) return vistas.get(i);
        const fotos = enlaces[i].__fotos || [];
        const ancho = Math.min(2000, Math.ceil((medios.clientWidth || 800) * (window.devicePixelRatio || 1) / 100) * 100);
        const capa = document.createElement('div');
        capa.className = 'wk-vista';
        capa.setAttribute('aria-hidden', 'true');
        const ul = document.createElement('ul');
        ul.className = 'wk-vista__lista';
        fotos.forEach(src => {
          const li = document.createElement('li');
          const img = document.createElement('img');
          img.alt = '';
          img.decoding = 'async';
          img.addEventListener('load', () => plana(img), { once: true });
          img.src = conAncho(src, ancho);
          li.appendChild(img);
          ul.appendChild(li);
        });
        capa.appendChild(ul);
        let tira = null;
        if (fotos.length > 1) {
          tira = document.createElement('div');
          tira.className = 'wk-thumbs wk-thumbs--vista';
          tira.setAttribute('aria-hidden', 'true');
          const dentro = document.createElement('div');
          dentro.className = 'wk-thumbs__inner';
          fotos.forEach(src => {
            const b = document.createElement('span');
            b.className = 'wk-thumbs__item';
            const im = document.createElement('img');
            im.alt = '';
            im.width = 48;
            im.height = 48;
            im.src = conAncho(src, 120);
            b.appendChild(im);
            dentro.appendChild(b);
          });
          tira.appendChild(dentro);
        }
        const v = { capa, ul, tira, fotos, par: '' };
        vistas.set(i, v);
        return v;
      };
      const quitaVista = () => {
        if (vista) { vista.capa.remove(); if (vista.tira) vista.tira.remove(); vista = null; }
        medios.classList.remove('wk-con-vista');
        base = '';
      };
      const ponVista = i => {
        const v = i === activa || !galeria ? null : montaVista(i);
        if (!v || !v.fotos.length) { quitaVista(); return; }
        // Foto propia que se ve y a qué altura, antes de tapar la galería
        if (!base) {
          const g = fotoGrande();
          const li = g && g.closest('li');
          base = g ? (g.currentSrc || g.src) : '';
          baseArriba = li ? li.getBoundingClientRect().top - galeria.getBoundingClientRect().top : 0;
        }
        v.par = base ? pareja(base, v.fotos) : v.fotos[0];
        const j = Math.max(0, v.fotos.indexOf(v.par));
        if (vista !== v) {
          if (vista) { vista.capa.remove(); if (vista.tira) vista.tira.remove(); }
          medios.appendChild(v.capa);
          if (v.tira) medios.appendChild(v.tira);
          vista = v;
        }
        medios.classList.add('wk-con-vista');
        // La parecida, a la misma altura que la foto propia que se veía
        v.ul.scrollTop = j * v.ul.clientHeight - baseArriba;
        if (v.tira) v.tira.querySelectorAll('.wk-thumbs__item').forEach((b, k) => {
          b.classList.toggle('is-active', k === j);
          b.classList.toggle('wk-vecina', Math.abs(k - j) === 1);
        });
      };
      const ponFoto = i => {
        if (i === enFoto) return;
        if (mq.matches) { ponVista(i); enFoto = i; return; }
        if (i === activa) { devuelveFoto(); return; }
        const img = cambiada || fotoGrande();
        const src = img && pareja(cambiada ? cambiada.dataset.wkFmtSrc : (img.currentSrc || img.src), enlaces[i].__fotos);
        if (!src) { devuelveFoto(); enFoto = i; return; }
        if (!cambiada) {
          img.dataset.wkFmtSrc = img.currentSrc || img.src;
          img.dataset.wkFmtSet = img.getAttribute('srcset') || '';
          cambiada = img;
        }
        img.removeAttribute('srcset');
        img.src = src;
        enFoto = i;
      };
      // 16/10 ("Bisel"): en el centro, la foto principal del formato que queda arriba (cambia al girar)
      let enCentro = -1;
      const fotoCentro = i => {
        if (i === enCentro) return;
        enCentro = i;
        const raw = enlaces[i] && (enlaces[i].dataset.wkFoto || (enlaces[i].__fotos || [])[0]);
        if (!raw) { centro.style.removeProperty('--wk-rueda-foto'); return; }
        try {
          const u = new URL(raw, location.href);
          u.searchParams.set('width', '200');
          centro.style.setProperty('--wk-rueda-foto', 'url("' + u.href + '")');
        } catch (e) {}
      };
      const pinta = p => {
        anillo.setAttribute('transform', 'rotate(' + (-p * paso) + ' ' + mitad + ' ' + mitad + ')');
        const arriba = ((Math.round(p) % n) + n) % n;
        textos.forEach((t, i) => t.classList.toggle('is-arriba', i === arriba));
        fotoCentro(arriba);
        ponFoto(arriba);
      };
      pinta(pos);
      let anim = 0;
      const anima = (hasta, fin) => {
        cancelAnimationFrame(anim);
        const desde = pos, t0 = performance.now();
        const avanza = ahora => {
          const k = Math.min(1, (ahora - t0) / 180);
          pos = desde + (hasta - desde) * (1 - Math.pow(1 - k, 3));
          pinta(pos);
          if (k < 1) anim = requestAnimationFrame(avanza);
          else if (fin) fin();
        };
        anim = requestAnimationFrame(avanza);
      };
      // Ángulo del dedo respecto al centro de la rueda grande: crece desde su esquina de arriba a la derecha, que no se
      // mueve, así que el giro no salta mientras crece
      const angulo = e => {
        const r = rueda.getBoundingClientRect(), mitadGrande = rueda.offsetWidth / 2;
        return Math.atan2(e.clientY - (r.top + mitadGrande), e.clientX - (r.right - mitadGrande)) * 180 / Math.PI;
      };
      let toque = null;
      const precargadas = new Set();
      // Ordenador: con el ratón encima de la rueda se cargan ya las fotos de los otros formatos, para que al girar salgan al momento
      rueda.addEventListener('pointerenter', () => {
        if (mq.matches) enlaces.forEach((a, i) => { if (i !== activa) montaVista(i); });
      });
      rueda.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        cancelAnimationFrame(anim);
        // Al tocar se cargan las fotos de los otros formatos parecidas a la que se ve, para que el cambio al girar sea inmediato
        const vista = cambiada ? cambiada.dataset.wkFmtSrc : ((fotoGrande() || {}).currentSrc || '');
        enlaces.forEach((a, i) => {
          const src = i === activa ? '' : (vista ? pareja(vista, a.__fotos) : a.dataset.wkFoto);
          if (src && !precargadas.has(src)) { precargadas.add(src); const im = new Image(); im.src = src; }
        });
        rueda.setPointerCapture(e.pointerId);
        rueda.classList.add('is-pulsada');
        toque = { ultimo: angulo(e), giro: 0, x: e.clientX, y: e.clientY, inicio: pos, movido: false };
      });
      rueda.addEventListener('pointermove', e => {
        if (!toque) return;
        const a = angulo(e);
        let d = a - toque.ultimo;
        if (d > 180) d -= 360;
        else if (d < -180) d += 360;
        toque.giro += d;
        toque.ultimo = a;
        if (Math.hypot(e.clientX - toque.x, e.clientY - toque.y) > 6) toque.movido = true;
        // Girar en el sentido de las agujas del reloj trae a la cima el nombre de la izquierda
        if (toque.movido) { pos = toque.inicio - toque.giro / paso; pinta(pos); }
      });
      rueda.addEventListener('pointerup', e => {
        if (!toque) return;
        let destino = toque.movido ? Math.round(pos) : Math.round(toque.inicio) + 1;
        // Ordenador: pulsar un nombre (sin girar) lleva a ese formato por el camino más corto; pulsar el actual no hace nada
        if (!toque.movido && mq.matches) {
          const el = document.elementsFromPoint(e.clientX, e.clientY).find(x => x.closest && x.closest('.wk-rueda text'));
          const j = el ? textos.indexOf(el.closest('text')) : -1;
          if (j > -1) {
            const base = Math.round(toque.inicio);
            let d = ((j - base) % n + n) % n;
            if (d > n / 2) d -= n;
            destino = base + d;
          }
        }
        toque = null;
        rueda.classList.remove('is-pulsada');
        const i = ((destino % n) + n) % n;
        // La ficha del otro formato se abre en la foto que se estaba viendo (#wk-foto=archivo), si no es su primera
        anima(destino, () => {
          if (i === activa) return;
          const ir = new URL(enlaces[i].href, location.href);
          const f = cambiada && enFoto === i ? nombreFoto(cambiada.src) : vista && enFoto === i && vista.par ? nombreFoto(vista.par) : '';
          if (f && f !== nombreFoto(enlaces[i].__fotos[0] || '')) ir.hash = 'wk-foto=' + encodeURIComponent(f);
          window.location.href = ir.href;
        });
      });
      rueda.addEventListener('pointercancel', () => {
        if (!toque) return;
        toque = null;
        rueda.classList.remove('is-pulsada');
        anima(activa);
      });
    };
    montarFormato().catch(() => {});
  } catch (e) {}

  // Al llegar desde la rueda de otro formato (#wk-foto=archivo), la ficha se abre en esa foto: en el móvil, el carrusel;
  // en el ordenador, la columna de fotos baja hasta ella (como al pulsar su miniatura)
  try {
    const m = location.hash.match(/^#wk-foto=([^&]+)$/);
    if (m) {
      const buscada = decodeURIComponent(m[1]).toLowerCase();
      history.replaceState(history.state, '', location.pathname + location.search);
      const carrusel = product.querySelector('.product__media-wrapper .swiper-product');
      const fotos = Array.from(product.querySelectorAll('media-gallery .product__media-list > li.product__media-item img'));
      const i = fotos.findIndex(img => nombreFoto(img.currentSrc || img.src) === buscada);
      if (i > 0 && mq.matches) {
        const li = fotos[i].closest('li');
        const lista = li && li.closest('.product__media-list');
        const baja = () => {
          if (!lista) return;
          if (lista.scrollHeight > lista.clientHeight + 2) lista.scrollTop = li.getBoundingClientRect().top - lista.getBoundingClientRect().top + lista.scrollTop;
          else li.scrollIntoView({ block: 'start' });
        };
        baja();
        if (document.readyState !== 'complete') window.addEventListener('load', baja, { once: true });
      }
      let intentos = 0;
      const espera = i > 0 && carrusel && !mq.matches ? setInterval(() => {
        const sw = carrusel.swiper;
        if (!sw && ++intentos < 100) return;
        clearInterval(espera);
        if (!sw) return;
        if (sw.params && sw.params.loop) sw.slideToLoop(i, 0);
        else sw.slideTo(i, 0);
      }, 30) : 0;
    }
  } catch (e) {}

  // Títulos "Color¹ White" y "Talla⁶" (solo se cambia el texto; el botón de la guía de tallas se queda donde está)
  try {
    const ponTitulo = function (fs, texto, conValor) {
      const lg = fs && fs.querySelector('legend');
      if (!lg || !texto) return;
      const nodo = Array.from(lg.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
      const caja = document.createElement('span');
      caja.className = 'wk-leg';
      const nombre = document.createElement('span');
      nombre.className = 'wk-leg__k';
      nombre.textContent = texto;
      const sup = document.createElement('sup');
      sup.textContent = opciones(fs).length;
      caja.append(nombre, sup);
      if (conValor) {
        const valor = document.createElement('span');
        valor.className = 'wk-leg__v';
        valor.textContent = elegida(fs);
        caja.append(valor);
        fs.addEventListener('change', () => { valor.textContent = elegida(fs); });
      }
      if (nodo) lg.replaceChild(caja, nodo);
      else lg.insertBefore(caja, lg.firstChild);
    };
    ponTitulo(fsColor, cfg.tColor, true);
    ponTitulo(fsTalla, cfg.tTalla, false);
  } catch (e) {}

  // Tallas de niño (15/10, /creativo S "Solo la edad"): si todas son edades ("3-4 Years"...), se ve solo "3-4"... en una
  // línea y la unidad sale una vez junto a "Talla", en el idioma de la tienda. Solo cambia el texto (la talla es la misma)
  try {
    const edad = /^(\s*\d+\s*-\s*\d+)\s*years?\s*$/i;
    const textoDe = l => Array.from(l.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
    const etiquetas = fsTalla ? opciones(fsTalla).map(i => fsTalla.querySelector('label[for="' + i.id + '"]')).filter(Boolean) : [];
    if (etiquetas.length && etiquetas.every(l => textoDe(l) && edad.test(textoDe(l).textContent))) {
      etiquetas.forEach(l => { const t = textoDe(l); t.textContent = t.textContent.replace(edad, '$1').trim(); });
      fsTalla.classList.add('wk-tallas-edad');
      const sup = fsTalla.querySelector('.wk-leg sup');
      if (sup) {
        const u = document.createElement('span');
        u.className = 'wk-leg__u';
        u.textContent = '· ' + ({ es: 'años', de: 'Jahre', fr: 'ans', it: 'anni', nl: 'jaar', pt: 'anos' }[cfg.lang] || 'years');
        sup.after(u);
      }
    }
  } catch (e) {}

  // Las opciones de cada grupo van en una caja .wk-pista (en ordenador, las tallas son una pista gris).
  // Con un solo color, el grupo lleva .wk-uno y en ordenador no se repite la muestra.
  try {
    grupos.forEach(fs => {
      const esColor = fs === fsColor;
      fs.classList.add(esColor ? 'wk-fs-color' : 'wk-fs-talla');
      if (esColor && opciones(fs).length === 1) fs.classList.add('wk-uno');
      const pista = document.createElement('div');
      pista.className = 'wk-pista';
      Array.from(fs.querySelectorAll(':scope > input[type="radio"]')).forEach(inp => {
        const lab = inp.nextElementSibling;
        pista.appendChild(inp);
        if (lab && lab.tagName === 'LABEL') pista.appendChild(lab);
      });
      if (pista.children.length) fs.appendChild(pista);
    });
  } catch (e) {}

  // Muestras de color con la foto de la prenda (la de la primera variante de ese color)
  try {
    const m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (fsColor && m) {
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(raiz + 'products/' + m[1] + '.js')
        .then(r => (r.ok ? r.json() : null))
        .then(p => {
          if (!p || !p.variants) return;
          const primera = opciones(fsColor)[0];
          const idx = (p.options || []).findIndex(o => (o && o.name ? o.name : o) === (primera && primera.name));
          opciones(fsColor).forEach(inp => {
            const lab = inp.nextElementSibling;
            if (!lab || !lab.classList.contains('swatch-color')) return;
            const v = p.variants.find(v => v.featured_image && v.featured_image.src && v.options &&
              (idx >= 0 ? v.options[idx] === inp.value : v.options.indexOf(inp.value) >= 0));
            // Un solo color sin foto propia: la foto principal del producto
            const src = v ? v.featured_image.src : (opciones(fsColor).length === 1 && typeof p.featured_image === 'string' ? p.featured_image : '');
            if (!src) return;
            const u = new URL(src, location.href);
            u.searchParams.set('width', '200');
            lab.style.setProperty('background-image', 'url("' + u.href + '")', 'important');
            lab.classList.add('wk-sw-foto');
          });
        })
        .catch(() => {});
    }
  } catch (e) {}

  // Línea de envío encima del botón: "Envío a España en <b>1-2 días laborables</b>."
  try {
    const pf = info && info.querySelector('product-form');
    if (pf && cfg.pais && cfg.dias && cfg.tEnvio && cfg.tEnvio.indexOf('{dias}') > -1) {
      const partes = cfg.tEnvio.split('{dias}');
      const linea = document.createElement('p');
      linea.className = 'wk-envio';
      const b = document.createElement('b');
      b.textContent = cfg.dias + partes[1].replace(/\.\s*$/, '');
      linea.append(document.createTextNode(partes[0].replace('{pais}', cfg.pais)), b, document.createTextNode('.'));
      pf.parentNode.insertBefore(linea, pf);
    }
  } catch (e) {}

  // Aviso "3 camisetas por 39€": sale encima de la foto, abajo, en cristal verde; al tocarlo baja a "Completa tu combo".
  // El texto es el del aviso del tema (ya traducido) y el del enlace, el título del combo (lo traduce la app).
  try {
    const aviso = info && info.querySelector('.pdp-3x39');
    const negrita = aviso && (aviso.querySelector('b') || aviso);
    const textoAviso = negrita ? negrita.textContent.trim() : '';
    const medios = product.querySelector('.product__media-wrapper');
    if (aviso && textoAviso && medios) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'wk-3x39';
      const punto = document.createElement('span');
      punto.className = 'wk-3x39__punto';
      punto.setAttribute('aria-hidden', 'true');
      const t = document.createElement('span');
      t.className = 'wk-3x39__t';
      t.textContent = textoAviso;
      const ir = document.createElement('span');
      ir.className = 'wk-3x39__ir';
      b.append(punto, t, ir);
      medios.appendChild(b);
      aviso.classList.add('wk-3x39-fuera');

      const elCombo = () => document.querySelector('.wk-combo .essential-upsell-cross-sell-block') || document.querySelector('.essential-upsell-cross-sell-block');
      // Si el texto no cabe en una línea (móvil), el enlace baja a una segunda línea
      const dosLineas = function () {
        b.classList.remove('wk-3x39--2l');
        if (ir.textContent && ir.offsetTop > t.offsetTop + 4) b.classList.add('wk-3x39--2l');
      };
      // En el móvil la pastilla se coloca sobre el bajo de la foto: se mide dónde acaba la foto
      const midoFoto = function () {
        const slide = medios.querySelector('.swiper-product .swiper-slide');
        if (!slide || mq.matches) return;
        const fin = slide.getBoundingClientRect().bottom - medios.getBoundingClientRect().top;
        if (fin > 0) medios.style.setProperty('--wk-foto-fin', Math.round(fin) + 'px');
      };
      const recoloca = function () { midoFoto(); dosLineas(); };
      const ponEnlace = function () {
        const tit = document.querySelector('.essential-upsell-cross-sell-block [data-essential-upsell-element="header"] [data-essential-upsell-element="title"]');
        if (!tit || !tit.textContent.trim()) return false;
        ir.textContent = tit.textContent.trim() + ' ↓';
        dosLineas();
        return true;
      };
      recoloca();
      new ResizeObserver(recoloca).observe(medios);
      window.addEventListener('load', recoloca);
      if (!ponEnlace()) {
        const espera = new MutationObserver(() => { if (ponEnlace()) espera.disconnect(); });
        espera.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => espera.disconnect(), 10000);
      }
      b.addEventListener('click', () => {
        const c = elCombo();
        if (c) window.scrollTo({ top: c.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
      });
    }
  } catch (e) {}

  // "Pago express" en lugar del botón de pago rápido de Shopify: añade la prenda elegida al carrito
  // (sin quitar lo que ya hubiera) y abre la página de pago, donde están todos los métodos
  try {
    const plantilla = document.getElementById('wk-pago-express');
    const pf = info && info.querySelector('product-form');
    const btnAdd = pf && pf.querySelector('button[name="add"]');
    if (plantilla && pf && btnAdd) {
      const express = plantilla.content.firstElementChild.cloneNode(true);
      pf.insertAdjacentElement('afterend', express);
      const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sincroniza = function () { express.disabled = btnAdd.disabled; };
      sincroniza();
      new MutationObserver(sincroniza).observe(btnAdd, { attributes: true, attributeFilter: ['disabled'] });
      express.addEventListener('click', () => {
        const campoId = pf.querySelector('input[name="id"]');
        const id = campoId && campoId.value;
        if (!id || express.disabled) return;
        const campoCant = document.querySelector('input[name="quantity"][form="' + (campoId.form ? campoId.form.id : '') + '"]') || (campoId.form && campoId.form.querySelector('input[name="quantity"]'));
        const cantidad = Math.max(1, parseInt(campoCant && campoCant.value, 10) || 1);
        express.classList.add('is-cargando');
        express.disabled = true;
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: cantidad }] })
        })
          .then(r => {
            if (!r.ok) throw new Error('add');
            window.location.href = raiz + 'checkout';
          })
          .catch(() => {
            express.classList.remove('is-cargando');
            sincroniza();
          });
      });
    }
  } catch (e) {}

  // Confianza y Eden: las tres columnas de confianza y, debajo, Eden en una línea (ordenador y móvil)
  try {
    const eden = info && info.querySelector('.eden-pdp');
    const confianza = info && info.querySelector('.pdp-trust');
    if (eden && confianza) {
      // En ordenador y móvil, como en el ordenador: primero la confianza y Eden debajo
      confianza.insertAdjacentElement('afterend', eden);
    }
  } catch (e) {}

  // Móvil: los tres desplegables pasan a ser pestañas "Subrayado" (nombres cortos sobre una raya fina). Cada pestaña
  // abre su desplegable debajo y, tocada otra vez, lo cierra. En el ordenador la fila no se ve (wk-pdp.css) y los
  // desplegables siguen en la columna izquierda. Los nombres vienen de #wk-pdp-config (data-t-tabs, por idioma)
  try {
    const desplegables = Array.from(product.querySelectorAll('.product__accordion')).filter(a => a.querySelector('details'));
    if (info && desplegables.length) {
      const nombres = (cfg.tTabs || '').split('|');
      const fila = document.createElement('div');
      fila.className = 'wk-tabs';
      fila.setAttribute('role', 'tablist');
      let botones = [];
      const marca = function () {
        desplegables.forEach((acc, i) => {
          const abierto = acc.querySelector('details').open;
          acc.classList.toggle('wk-abierto', abierto);
          if (botones[i]) {
            botones[i].classList.toggle('on', abierto);
            botones[i].setAttribute('aria-selected', abierto ? 'true' : 'false');
          }
        });
      };
      botones = desplegables.map((acc, i) => {
        const d = acc.querySelector('details');
        const titulo = acc.querySelector('.accordion__title');
        acc.classList.add('wk-tab-panel');
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.textContent = nombres[i] || (titulo ? titulo.textContent.trim() : '');
        b.addEventListener('click', () => {
          const abrir = !d.open;
          desplegables.forEach(x => {
            const dx = x.querySelector('details');
            if (dx !== d) dx.open = false;
          });
          d.open = abrir;
          marca();
        });
        d.addEventListener('toggle', marca);
        fila.appendChild(b);
        return b;
      });
      // Delante de la marca del primer desplegable: así sigue en su sitio cuando la sección los lleva y los trae
      // entre la columna izquierda (ordenador) y la ficha (móvil)
      const ancla = (desplegables[0].__wkPh && desplegables[0].__wkPh.parentNode) ? desplegables[0].__wkPh : desplegables[0];
      ancla.parentNode.insertBefore(fila, ancla);
      marca();
    }
  } catch (e) {}

  // Detalles, Envíos e Información (15/10, ordenador y móvil): como mucho 200 px, terminando en una línea entera (cambia
  // con el ancho, porque la letra no es la misma). Si el texto es más largo, se desvanece abajo (dos líneas) y, cuando
  // ya se ha bajado, también arriba; al llegar al final, el degradado de abajo se va (wk-pdp.css)
  try {
    const ALTO = 200;
    Array.from(product.querySelectorAll('.product__accordion.wk-tab-panel .accordion__content')).forEach(c => {
      let lh = 0;
      const pinta = () => {
        const cs = getComputedStyle(c);
        const l = parseFloat(cs.lineHeight) || 0;
        if (l && l !== lh) {
          lh = l;
          const pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
          c.style.maxHeight = Math.round(pt + Math.floor((ALTO - pt - pb) / l) * l + pb) + 'px';
        }
        const arriba = c.scrollTop > 2, abajo = c.scrollTop + c.clientHeight < c.scrollHeight - 2;
        c.style.setProperty('--wk-arriba', arriba ? '28px' : '0px');
        c.style.setProperty('--wk-abajo', abajo ? Math.round((lh || 20) * 2) + 'px' : '0px');
      };
      c.addEventListener('scroll', pinta, { passive: true });
      // Al abrir el desplegable o la pestaña (antes mide 0) y al cambiar el texto de tamaño
      if (window.ResizeObserver) new ResizeObserver(() => requestAnimationFrame(pinta)).observe(c);
      alCambiarAncho(() => requestAnimationFrame(pinta));
      pinta();
    });
  } catch (e) {}

  // "Completa tu combo" (app) fuera de la sección de la ficha, en su propia franja con "page-width" justo antes de
  // "Podría gustarte" y con su mismo ancho, en ordenador y en móvil (15/10: antes, en el móvil, iba dentro de la columna)
  try {
    const combos = Array.from(product.querySelectorAll('.essential-upsell-cross-sell-block, .essential-upsell-frequently-bought-together-block'));
    if (combos.length) {
      const abajo = document.createElement('div');
      abajo.className = 'wk-combo page-width';
      (wrap.closest('.shopify-section') || wrap).insertAdjacentElement('afterend', abajo);
      combos.forEach(c => abajo.appendChild(c));

      // En el escaparate las fotos se ven grandes: la app las pide de 128 px, se cambian por unas de 800
      const fotosGrandes = function () {
        const ancho = 800;
        combos.forEach(c => c.querySelectorAll('img[data-essential-upsell-element="image"]').forEach(img => {
          if (+img.dataset.wkHd >= ancho || !img.src) return;
          const u = new URL(img.src, location.href);
          if (!u.searchParams.has('width')) return;
          u.searchParams.set('width', String(ancho));
          img.dataset.wkHd = String(ancho);
          img.removeAttribute('srcset');
          img.src = u.href;
        }));
      };
      fotosGrandes();
      combos.forEach(c => new MutationObserver(fotosGrandes).observe(c, { childList: true, subtree: true }));

      // Como "Podría gustarte" (15/10): fuera los recuadros vacíos con "Add" que la app pone detrás de las prendas, el
      // número de prendas en superíndice en el título, el precio con el formato del tema (data-dinero de #wk-pdp-config:
      // 1234,56 escrito como el tema escribe los precios en el país de la visita) y, desde 750 px, la segunda foto de la
      // prenda al pasar el ratón por la foto (como .hover-img del tema), que se pide a /products/<handle>.js la primera vez
      const dinero = (function () {
        const m = (cfg.dinero || '').match(/\d[\d.,'\s  ]*\d/);
        if (!m) return null;
        const num = m[0], seps = num.match(/[^\d]/g) || [];
        const tras = (num.match(/(\d+)$/) || ['', ''])[1].length;
        const conDecimales = seps.length > 0 && tras !== 3;
        return {
          plantilla: cfg.dinero.replace(num, '{n}'),
          decimales: conDecimales ? tras : 0,
          dec: conDecimales ? seps[seps.length - 1] : '',
          mil: conDecimales ? (seps.length > 1 ? seps[0] : '') : (seps[0] || '')
        };
      })();
      const formatea = function (txt) {
        const m = dinero && String(txt).match(/\d[\d.,'\s  ]*\d|\d/);
        if (!m) return '';
        const d = m[0].match(/^(.*?)[.,](\d{1,2})$/);
        const valor = Number((d ? d[1] : m[0]).replace(/[^\d]/g, '') + '.' + (d ? d[2] : '0'));
        if (!isFinite(valor)) return '';
        const partes = valor.toFixed(dinero.decimales).split('.');
        const entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, dinero.mil);
        return dinero.plantilla.replace('{n}', entero + (partes[1] ? dinero.dec + partes[1] : ''));
      };
      const segundaFoto = function () {
        const marco = this;
        if (marco.dataset.wkHover || innerWidth < 750) return;
        marco.dataset.wkHover = '1';
        const prod = marco.closest('[data-essential-upsell-element="product"]');
        const a = prod && prod.querySelector('a[data-essential-upsell-element="title"]');
        const h = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!h) return;
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + h[1] + '.js')
          .then(r => (r.ok ? r.json() : null))
          .then(p => {
            const src = p && p.images && p.images[1];
            if (!src) return;
            const u = new URL(src, location.href);
            u.searchParams.set('width', '800');
            const img = document.createElement('img');
            img.className = 'wk-combo-hover';
            img.alt = '';
            img.src = u.href;
            const base = marco.querySelector('[data-essential-upsell-element="image"]');
            if (base) base.insertAdjacentElement('afterend', img);
            else marco.prepend(img);
          })
          .catch(() => {});
      };
      const igualaGustarte = function () {
        combos.forEach(c => {
          const lista = c.querySelector('[data-essential-upsell-element="products"]');
          if (!lista) return;
          const prendas = new Set();
          Array.from(lista.children).forEach(h => {
            // Vacío = sin prenda o con la tarjeta de la app sin nombre (solo "Add")
            const prod = h.matches('[data-essential-upsell-element="product"]') ? h : h.querySelector('[data-essential-upsell-element="product"]');
            const a = prod && prod.querySelector('a[data-essential-upsell-element="title"]');
            if (h.classList.contains('wk-combo-vacio') !== !a) h.classList.toggle('wk-combo-vacio', !a);
            if (!a) return;
            prendas.add((a.getAttribute('href') || '').split('?')[0]);
            const marco = prod.querySelector('[data-essential-upsell-element="image-container"]');
            if (marco && !marco.dataset.wkHoverOn) {
              marco.dataset.wkHoverOn = '1';
              marco.addEventListener('mouseenter', segundaFoto);
            }
          });
          const titulo = c.querySelector('[data-essential-upsell-element="header"] [data-essential-upsell-element="title"]');
          if (titulo && prendas.size) {
            let sup = titulo.querySelector('.wk-rec-count');
            if (!sup) {
              sup = document.createElement('sup');
              sup.className = 'wk-rec-count';
              titulo.appendChild(sup);
            }
            if (sup.textContent !== String(prendas.size)) sup.textContent = String(prendas.size);
          }
          c.querySelectorAll('[data-essential-upsell-element="price"] [data-essential-upsell-element$="price"]').forEach(p => {
            if (p.childElementCount || p.dataset.wkPrecio === p.textContent) return;
            const nuevo = formatea(p.textContent);
            if (nuevo && nuevo !== p.textContent) p.textContent = nuevo;
            p.dataset.wkPrecio = p.textContent;
          });
        });
      };
      igualaGustarte();
      combos.forEach(c => new MutationObserver(igualaGustarte).observe(c, { childList: true, subtree: true, characterData: true }));

      // Botón de añadir como el de "Podría gustarte": la pieza quick-add-inline del tema (su CSS y su JS ya están en la
      // página). En ordenador, franja "AÑADIR + tallas" abajo de la foto al pasar el ratón; en el móvil, "+" que abre la
      // hoja de tallas del tema. Las tallas salen del desplegable de la app (valor = variante, texto "talla / color",
      // desactivada = agotada), solo las del color que se ve. El botón y el desplegable de la app se esconden (wk-pdp.css).
      const MAS = '<svg class="quick-add-inline__icon quick-add-inline__icon--plus" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line></svg>';
      const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      const parte = t => { const i = t.indexOf(' / '); return i < 0 ? [t, ''] : [t.slice(0, i), t.slice(i + 3)]; };
      let nQai = 0;
      const montaQai = function () {
        combos.forEach(c => c.querySelectorAll('[data-essential-upsell-element="product"]').forEach(prod => {
          if (prod.querySelector('.wk-qai')) return;
          const sel = prod.querySelector('select');
          const foto = prod.querySelector('[data-essential-upsell-element="image-container"]');
          if (!sel || !foto || !sel.options.length) return;
          const color = parte(sel.options[sel.selectedIndex >= 0 ? sel.selectedIndex : 0].text)[1];
          const tallas = Array.from(sel.options).filter(o => parte(o.text)[1] === color)
            .map(o => ({ id: o.value, talla: parte(o.text)[0], agotada: o.disabled }));
          const precio = prod.querySelector('[data-product-id]');
          const pid = precio ? precio.getAttribute('data-product-id') : '';
          const cont = prod.closest('[data-essential-upsell-funnel-id]');
          const funnel = cont ? cont.getAttribute('data-essential-upsell-funnel-id') : '';
          const w = document.createElement('div');
          w.className = 'card-wrapper wk-qai';
          w.id = 'wkqai-' + pid + '-' + (nQai++);
          w.innerHTML = '<div class="card__inner">'
            + '<button type="button" class="quick-add-inline__trigger" aria-label="' + esc(cfg.tQaiAria || '') + '" aria-expanded="false" data-qai-placed="1">' + MAS + '</button>'
            + '<div class="quick-add-inline" data-product-id="' + esc(w.id) + '" data-qai-placed="1">'
            + '<span class="quick-add-inline__label">' + esc(cfg.tQai || '') + '</span><div class="quick-add-inline__sizes">'
            + tallas.map(t => '<button type="button" class="quick-add-inline__size wk-qai__talla' + (t.agotada ? ' quick-add-inline__size--unavailable' : '') + '"'
              + ' data-variant-id="' + esc(t.id) + '" data-size="' + esc(t.talla) + '" data-wk-funnel="' + esc(funnel) + '" data-wk-pid="' + esc(pid) + '"'
              + ' aria-label="' + esc(t.talla) + (t.agotada ? ' (' + esc(cfg.tAgotado || '') + ')' : '') + '"' + (t.agotada ? ' disabled aria-disabled="true"' : '') + '>'
              + esc(t.talla) + '</button>').join('')
            + '</div></div></div>';
          foto.appendChild(w);
          prod.classList.add('wk-qai-on');
        }));
      };
      montaQai();
      combos.forEach(c => new MutationObserver(montaQai).observe(c, { childList: true, subtree: true }));

      // Al elegir talla se añade como lo hace la app, con sus dos datos ocultos (así la app sigue contando las ventas del
      // combo), y se abre el carrito del tema como en quick-add-inline.js. Va en la fase de captura de window para llegar
      // antes que quick-add-inline.js (que añadiría sin esos datos).
      const anadeCombo = function (b) {
        if (b.dataset.qaiBusy === '1') return;
        b.dataset.qaiBusy = '1';
        b.classList.add('is-loading');
        const carrito = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const fd = new FormData();
        fd.append('id', b.getAttribute('data-variant-id'));
        fd.append('quantity', '1');
        if (b.dataset.wkFunnel) fd.append('properties[__essential_upsell_funnel_id]', b.dataset.wkFunnel);
        if (b.dataset.wkPid) fd.append('properties[__essential_upsell_product_id]', b.dataset.wkPid);
        if (carrito) {
          fd.append('sections', carrito.getSectionsToRender().map(s => s.id).join(','));
          fd.append('sections_url', location.pathname);
          carrito.setActiveElement(document.activeElement);
        }
        const suelta = () => { b.classList.remove('is-loading'); delete b.dataset.qaiBusy; };
        const url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        // Si Shopify frena por exceso de peticiones devuelve HTML en vez de JSON: se reintenta, como en quick-add-inline.js
        const intenta = n => fetch(url, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(r => {
            const json = (r.headers.get('content-type') || '').indexOf('application/json') !== -1;
            if (!r.ok && !json) {
              if (n < 3) return new Promise(ok => setTimeout(() => ok(intenta(n + 1)), 300 * n));
              throw new Error('cart_throttled');
            }
            return r.json();
          });
        intenta(1).then(res => {
          suelta();
          if (res.status) { alert(res.description || res.message || ''); return; }
          if (!carrito) { location = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (document.body.classList.contains('qai-sheet-active')) {
            const fondo = document.getElementById('qai-sheet-backdrop');
            if (fondo) fondo.click();
          }
          carrito.classList.remove('is-empty');
          carrito.renderContents(res);
          b.classList.add('is-added');
          setTimeout(() => b.classList.remove('is-added'), 1000);
        }).catch(suelta);
      };
      window.addEventListener('click', function (ev) {
        const b = ev.target && ev.target.closest && ev.target.closest('.wk-qai__talla');
        if (!b) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (b.disabled || b.classList.contains('quick-add-inline__size--unavailable')) return;
        anadeCombo(b);
      }, true);
    }
  } catch (e) {}

  // Fotos planas (esquinas blancas): enteras; el resto, a sangre
  try {
    const marca = function (img) {
      try {
        const c = document.createElement('canvas');
        c.width = c.height = 16;
        const x = c.getContext('2d');
        x.drawImage(img, 0, 0, 16, 16);
        const d = x.getImageData(0, 0, 16, 16).data;
        const esquinas = [[d[0], d[1], d[2]], [d[60], d[61], d[62]], [d[960], d[961], d[962]], [d[1020], d[1021], d[1022]]];
        if (esquinas.every(([r, g, b]) => r >= 240 && g >= 240 && b >= 240)) img.classList.add('wk-plana');
      } catch (e) {}
    };
    product.querySelectorAll('.product__media-list .product__media-item img').forEach(img => {
      if (img.complete && img.naturalWidth) marca(img);
      else img.addEventListener('load', () => marca(img), { once: true });
    });
  } catch (e) {}

  try {
    if (thumbsEnabled) {
      var mediaWrapper = product.querySelector('.product__media-wrapper');
      if (mediaWrapper) {
        var thumbsDiv = document.createElement('div');
        thumbsDiv.className = 'wk-thumbs';
        var thumbsInner = document.createElement('div');
        thumbsInner.className = 'wk-thumbs__inner';
        thumbsDiv.appendChild(thumbsInner);
        mediaWrapper.appendChild(thumbsDiv);

        var list = mediaWrapper.querySelector('media-gallery .product__media-list');
        if (!list) throw new Error('wk-pdp: sin galería');

        var ratios = new Map();
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
          var mostVisible = null, maxRatio = 0;
          ratios.forEach(function (ratio, li) {
            if (ratio > maxRatio) { maxRatio = ratio; mostVisible = li; }
          });
          if (mostVisible) setActive(mostVisible);
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

        function setActive(li) {
          // En el ordenador la activa crece y sus dos vecinas quedan a medio tamaño (tira "Dock")
          var btns = Array.prototype.slice.call(thumbsInner.querySelectorAll('.wk-thumbs__item'));
          var ia = -1;
          btns.forEach(function (btn, i) {
            var on = btn.__li === li;
            btn.classList.toggle('is-active', on);
            if (on) ia = i;
          });
          btns.forEach(function (btn, i) {
            btn.classList.toggle('wk-vecina', ia >= 0 && Math.abs(i - ia) === 1);
          });
          var activeBtn = thumbsInner.querySelector('.wk-thumbs__item.is-active');
          if (activeBtn) {
            var top = activeBtn.offsetTop, bottom = top + activeBtn.offsetHeight;
            if (top < thumbsInner.scrollTop) thumbsInner.scrollTop = top;
            else if (bottom > thumbsInner.scrollTop + thumbsInner.clientHeight)
              thumbsInner.scrollTop = bottom - thumbsInner.clientHeight;
            // En el móvil la fila es horizontal: se desplaza de lado
            var left = activeBtn.offsetLeft, right = left + activeBtn.offsetWidth;
            if (left < thumbsInner.scrollLeft) thumbsInner.scrollLeft = left - 8;
            else if (right > thumbsInner.scrollLeft + thumbsInner.clientWidth)
              thumbsInner.scrollLeft = right - thumbsInner.clientWidth + 8;
          }
        }

        // Móvil: las fotos van en un carrusel (swiper). Tocar una miniatura lleva a su foto y,
        // al deslizar las fotos, se marca su miniatura. Mismo orden que la lista del ordenador.
        var carrusel = mediaWrapper.querySelector('.swiper-product');
        function marcaPorIndice(i) {
          var btns = thumbsInner.querySelectorAll('.wk-thumbs__item');
          if (btns[i]) setActive(btns[i].__li);
        }
        if (carrusel) {
          var intentos = 0;
          var engancha = setInterval(function () {
            intentos++;
            if (carrusel.swiper) {
              clearInterval(engancha);
              carrusel.swiper.on('slideChange', function () { marcaPorIndice(carrusel.swiper.realIndex); });
              if (!mq.matches) marcaPorIndice(carrusel.swiper.realIndex || 0);
            } else if (intentos > 50) clearInterval(engancha);
          }, 200);
        }

        function build() {
          io.disconnect();
          ratios.clear();
          thumbsInner.innerHTML = '';
          var items = list.querySelectorAll(':scope > li.product__media-item');
          if (items.length <= 1) return;
          items.forEach(function (li) {
            var img = li.querySelector('img');
            if (!img) return;
            var u = new URL(img.currentSrc || img.src, location.href);
            u.searchParams.set('width', '120');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'wk-thumbs__item';
            btn.__li = li;
            var thumbImg = document.createElement('img');
            thumbImg.src = u.toString();
            thumbImg.alt = '';
            thumbImg.width = 48;
            thumbImg.height = 48;
            thumbImg.loading = 'lazy';
            btn.appendChild(thumbImg);
            btn.__i = thumbsInner.children.length;
            btn.addEventListener('click', function () {
              // Móvil: el carrusel pasa a esa foto
              if (!mq.matches && carrusel && carrusel.swiper) {
                if (carrusel.swiper.params && carrusel.swiper.params.loop) carrusel.swiper.slideToLoop(btn.__i);
                else carrusel.swiper.slideTo(btn.__i);
                return;
              }
              // Con la columna de fotos fija se desplaza la lista; si no, la página
              if (list.scrollHeight > list.clientHeight + 2) {
                var y = li.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
                list.scrollTo({ top: y, behavior: 'smooth' });
              } else {
                li.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            });
            thumbsInner.appendChild(btn);
            io.observe(li);
          });
        }

        var resizeObs = new ResizeObserver(function () {
          thumbsInner.style.setProperty('--wk-thumbs-h', thumbsInner.offsetHeight + 'px');
        });
        resizeObs.observe(thumbsInner);

        var mutObs = new MutationObserver(function () {
          clearTimeout(mutObs.__timeout);
          mutObs.__timeout = setTimeout(build, 100);
        });
        mutObs.observe(list, { childList: true });

        build();
      }
    }
  } catch (e) {}

  try {
    if (tintEnabled) {
      function updateTint() {
        try {
          const variantRadios = product.querySelector('variant-radios');
          if (!variantRadios) return;
          const checked = Array.from(variantRadios.querySelectorAll('input[type="radio"]:checked')).find(function (i) {
            return i.nextElementSibling && i.nextElementSibling.classList.contains('swatch-color');
          });
          if (!checked) return;
          const label = checked.nextElementSibling;
          if (!label || !label.classList.contains('swatch-color')) return;
          const bgImage = getComputedStyle(label).backgroundImage;
          const url = bgImage.match(/url\(["']?([^"')]+)["']?\)/)?.[1];
          if (!url) return;

          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = 8;
            canvas.height = 8;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, 8, 8);
            const data = ctx.getImageData(0, 0, 8, 8).data;
            let r = 0, g = 0, b = 0, count = 0;
            for (let i = 0; i < data.length; i += 4) {
              if (data[i + 3] > 0) {
                r += data[i];
                g += data[i + 1];
                b += data[i + 2];
                count++;
              }
            }
            if (count > 0) {
              r = Math.round(r / count);
              g = Math.round(g / count);
              b = Math.round(b / count);
              const tint = `rgb(${Math.round(r + (255 - r) * 0.88)}, ${Math.round(g + (255 - g) * 0.88)}, ${Math.round(b + (255 - b) * 0.88)})`;
              const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
              if (lum > 0.975) {
                product.style.setProperty('--wk-tint', 'rgb(244, 244, 242)');
              } else {
                product.style.setProperty('--wk-tint', tint);
              }
            }
          };
          img.onerror = () => {};
          img.src = url;
        } catch (e) {}
      }

      function checkImages() {
        const allImages = product.querySelectorAll('.product__media-item img, .swiper-product .swiper-slide img');
        allImages.forEach(img => {
          if (img.complete) {
            processImage(img);
          } else {
            img.addEventListener('load', () => processImage(img));
          }
        });
      }

      function processImage(img) {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 16;
          canvas.height = 16;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, 16, 16);
          const data = ctx.getImageData(0, 0, 16, 16).data;
          const corners = [
            [data[0], data[1], data[2]],
            [data[60], data[61], data[62]],
            [data[960], data[961], data[962]],
            [data[1020], data[1021], data[1022]]
          ];
          if (corners.every(([r, g, b]) => r >= 244 && g >= 244 && b >= 244)) {
            img.classList.add('wk-blend');
          }
        } catch (e) {}
      }

      updateTint();
      checkImages();
      const variantRadios = product.querySelector('variant-radios');
      if (variantRadios) {
        variantRadios.addEventListener('change', () => {
          setTimeout(updateTint, 50);
          checkImages();
        });
      }
    }
  } catch (e) {}

  // Columnas de texto fijas debajo de la cabecera; si no caben, se pegan por abajo
  try {
    var ARRIBA = 104;
    function fitSticky() {
      var els = [product.querySelector('.wk-col-left__inner'), product.querySelector('.product__info-container')];
      els.forEach(function (el) {
        if (!el) return;
        if (!product.classList.contains('wk-3col')) { el.style.removeProperty('top'); return; }
        var top = Math.min(ARRIBA, window.innerHeight - el.offsetHeight - 12);
        el.style.setProperty('top', top + 'px', 'important');
      });
    }

    fitSticky();
    window.addEventListener('resize', fitSticky);

    var stickyResizeObs = new ResizeObserver(fitSticky);
    var el1 = product.querySelector('.wk-col-left__inner');
    var el2 = product.querySelector('.product__info-container');
    if (el1) stickyResizeObs.observe(el1);
    if (el2) stickyResizeObs.observe(el2);

    var classObs = new MutationObserver(fitSticky);
    classObs.observe(product, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}

  try {
    const btn = wrap.querySelector('product-form button[name="add"]');
    if (btn) {
      const priceSpan = document.createElement('span');
      priceSpan.className = 'wk-atc-price';
      priceSpan.setAttribute('aria-hidden', 'true');
      btn.appendChild(priceSpan);

      const sproutSpan = document.createElement('span');
      sproutSpan.className = 'wk-sprout';
      sproutSpan.setAttribute('aria-hidden', 'true');
      btn.appendChild(sproutSpan);

      function currentPrice() {
        const priceDiv = wrap.querySelector('div[id^="price-"]');
        if (!priceDiv) return '';
        const onSale = priceDiv.querySelector('.price--on-sale .price__sale .price-item--last');
        if (onSale) return onSale.textContent.trim();
        const regular = priceDiv.querySelector('.price__regular .price-item--regular');
        return regular ? regular.textContent.trim() : '';
      }

      function updatePrice() {
        priceSpan.textContent = currentPrice();
        priceSpan.classList.toggle('wk-atc-price--hidden', btn.disabled);
      }

      updatePrice();
      const priceDiv = wrap.querySelector('div[id^="price-"]');
      if (priceDiv) {
        const priceObs = new MutationObserver(updatePrice);
        priceObs.observe(priceDiv, { subtree: true, childList: true, characterData: true });
      }
    }
  } catch (e) {}

  // Barra fija del móvil: desplegables de color y talla arriba, botón negro debajo
  try {
    if (stickyBarEnabled) {
      const btnReal = wrap.querySelector('product-form button[name="add"]');
      const bar = document.createElement('div');
      bar.className = 'wk-sticky-atc';
      bar.setAttribute('aria-hidden', 'true');

      const fila = document.createElement('div');
      fila.className = 'wk-sticky-atc__sels';
      const repintar = [];

      const hazDesplegable = function (fs, texto) {
        const ops = opciones(fs);
        if (!ops.length) return;
        const caja = document.createElement('label');
        caja.className = 'wk-sel';
        const k = document.createElement('span');
        k.className = 'wk-sel__k';
        k.textContent = texto;
        const v = document.createElement('span');
        v.className = 'wk-sel__v';
        const sel = document.createElement('select');
        sel.setAttribute('aria-label', texto);
        ops.forEach(inp => {
          const o = document.createElement('option');
          o.value = inp.value;
          const lab = inp.nextElementSibling;
          o.textContent = (lab && !lab.classList.contains('swatch-color') && lab.textContent.trim().toUpperCase()) || inp.value;
          if (inp.disabled) o.disabled = true;
          sel.appendChild(o);
        });
        const pinta = function () {
          const actual = elegida(fs);
          if (actual) sel.value = actual;
          const o = sel.options[sel.selectedIndex];
          v.textContent = o ? o.textContent : '';
        };
        sel.addEventListener('change', () => {
          const inp = ops.find(i => i.value === sel.value);
          if (inp) {
            inp.checked = true;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
          pinta();
        });
        caja.append(k, v, sel);
        fila.appendChild(caja);
        repintar.push(pinta);
        pinta();
      };

      // Talla en "pista", como en la ficha: todas a la vista y se elige de un toque (16/10/2026)
      const hazPista = function (fs, texto) {
        const ops = opciones(fs);
        if (!ops.length) return;
        const pista = document.createElement('div');
        pista.className = 'wk-bpista';
        pista.setAttribute('role', 'radiogroup');
        pista.setAttribute('aria-label', texto);
        const botones = ops.map(inp => {
          const b = document.createElement('button');
          b.type = 'button';
          const lab = inp.nextElementSibling;
          b.textContent = (lab && !lab.classList.contains('swatch-color') && lab.textContent.trim().toUpperCase()) || inp.value;
          b.addEventListener('click', () => {
            if (inp.disabled) return;
            inp.checked = true;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
            pinta();
          });
          pista.appendChild(b);
          return b;
        });
        const pinta = function () {
          const actual = elegida(fs);
          ops.forEach((inp, i) => {
            botones[i].disabled = inp.disabled;
            botones[i].classList.toggle('is-on', inp.value === actual);
            botones[i].setAttribute('aria-checked', inp.value === actual ? 'true' : 'false');
          });
        };
        fila.appendChild(pista);
        repintar.push(pinta);
        pinta();
      };

      // El color solo sale si hay más de uno; si no, la talla ocupa su sitio
      if (fsColor && opciones(fsColor).length > 1) hazDesplegable(fsColor, cfg.tColor || 'Color');
      if (fsTalla) hazPista(fsTalla, cfg.tTalla || 'Size');
      if (radios) radios.addEventListener('change', () => repintar.forEach(f => f()));

      const atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'wk-sticky-atc__btn';
      const atcLabel = document.createElement('span');
      atcLabel.className = 'wk-sticky-atc__label';
      const atcPrice = document.createElement('span');
      atcPrice.className = 'wk-sticky-atc__price';
      atcBtn.append(atcLabel, atcPrice);

      if (fila.children.length) bar.appendChild(fila);
      bar.appendChild(atcBtn);
      document.body.appendChild(bar);

      if (btnReal) {
        atcBtn.addEventListener('click', () => {
          if (!btnReal.disabled) btnReal.click();
        });

        // El texto del botón es el del botón de verdad (ya viene traducido: "Añadir al carrito", "Agotado"...)
        // Texto del botón sin la línea de la tote (esa va en su propio span, .wk-atc-gift)
        const textoBoton = function (el) {
          const c = el.cloneNode(true);
          c.querySelectorAll('.wk-atc-gift').forEach(n => n.remove());
          return c.textContent.trim();
        };
        const syncBtn = function () {
          atcBtn.disabled = btnReal.disabled;
          const s = Array.from(btnReal.children).find(el => el.tagName === 'SPAN' && !el.classList.contains('wk-atc-price') && !el.classList.contains('wk-sprout'));
          (atcLabel.querySelector('.wk-atc-txt') || atcLabel).textContent = s ? textoBoton(s) : '';
          const precio = wrap.querySelector('.wk-atc-price');
          atcPrice.textContent = btnReal.disabled ? '' : ((precio && precio.textContent) || '');
        };
        syncBtn();
        new MutationObserver(syncBtn).observe(btnReal, { attributes: true, childList: true, subtree: true, characterData: true });
      }

      // 16/10: sale solo cuando "Pago express" ya ha quedado por encima de la pantalla (el cliente ha bajado más allá);
      // arriba del todo y mientras se ve, no. Sin "Pago express", como antes: siempre, salvo con el botón de verdad a la vista
      const muestra = function (si) {
        bar.classList.toggle('is-visible', si);
        bar.setAttribute('aria-hidden', si ? 'false' : 'true');
        document.body.classList.toggle('wk-bar-visible', si);
        if (si && bar.offsetHeight) document.documentElement.style.setProperty('--wk-bar-h', bar.offsetHeight + 'px');
      };
      const pagoExpress = wrap.querySelector('.wk-express');
      if (pagoExpress && pagoExpress.offsetParent) {
        new IntersectionObserver(entries => {
          entries.forEach(entry => muestra(!entry.isIntersecting && entry.boundingClientRect.bottom <= 0));
        }).observe(pagoExpress);
      } else if (btnReal) {
        new IntersectionObserver(entries => {
          entries.forEach(entry => muestra(!entry.isIntersecting));
        }).observe(btnReal);
      } else {
        muestra(true);
      }
    }
  } catch (e) {}

  // Semana Eden (19 al 25/10/2026): tote de regalo en la ficha. Solo si WKE.promo (lo fija wk-eden-semana.liquid).
  // Lo que se pone lleva data-wke="promo" y data-wke-tote, que wk-eden-semana.liquid oculta fuera de la promo o sin totes.
  // Si las totes se agotan, se quita todo. Fuera de la promo no se añade nada y la ficha queda como siempre.
  if (window.WKE && window.WKE.promo) {
    try {
      const W = window.WKE;
      const titulo = cfg.wkeTabTitulo || '';
      let hay = false, vigila = false, turno = 0;

      // Foto de la tote en el ancho pedido (mismo formato que assets/wk-eden-semana.js)
      const fotoTote = function (ancho) {
        const t = W.toteDatos;
        if (!t || !t.foto) return '';
        const u = t.foto.indexOf('//') === 0 ? 'https:' + t.foto : t.foto;
        return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + ancho;
      };
      const listas = () => Array.from(product.querySelectorAll('media-gallery .product__media-list'));
      // La lista que el tema usa para pintar la tira de miniaturas
      const principal = () => product.querySelector('.product__media-wrapper media-gallery .product__media-list');
      const tira = () => product.querySelector('.wk-thumbs__inner');
      // Las fotos van en el swiper del móvil (dentro de su .swiper-wrapper) o directamente en la lista del ordenador
      const contenedor = lista => lista.querySelector(':scope > .swiper-wrapper') || lista;
      const diapositivas = lista => Array.from(contenedor(lista).children).filter(c => c.matches('li.product__media-item, .swiper-slide'));
      const fotoDe = lista => contenedor(lista).querySelector(':scope > .wk-tote-foto');

      // La foto de la tote es la última de la galería: clon de la última foto, con la pastilla de cristal (solo ordenador)
      const ponFoto = function (lista, url) {
        if (fotoDe(lista)) return fotoDe(lista);
        const sl = diapositivas(lista);
        const ultima = sl[sl.length - 1];
        if (!ultima) return null;
        const f = ultima.cloneNode(true);
        f.removeAttribute('id');
        f.classList.remove('is-active', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
        f.classList.add('wk-tote-foto');
        f.setAttribute('data-wke', 'promo');
        f.setAttribute('data-wke-tote', '');
        if (f.hasAttribute('data-media-id')) f.setAttribute('data-media-id', 'wk-tote');
        f.querySelectorAll('[id]').forEach(e => { e.id = 'wk-' + e.id; });
        f.querySelectorAll('noscript, source').forEach(n => n.remove());
        const img = f.querySelector('img');
        if (!img) return null;
        img.src = url;
        img.srcset = url;
        img.alt = titulo;
        img.removeAttribute('loading');
        img.classList.remove('wk-plana');
        img.style.objectFit = 'cover';
        const media = f.querySelector('.product__media') || img.parentElement;
        media.style.position = 'relative';
        const pastilla = document.createElement('div');
        pastilla.className = 'wk-tote-pill';
        pastilla.setAttribute('data-wke', 'promo');
        pastilla.setAttribute('data-wke-tote', '');
        const p1 = document.createElement('b');
        p1.textContent = cfg.wkePillTitulo || '';
        const p2 = document.createElement('span');
        p2.textContent = cfg.wkePillSub || '';
        pastilla.append(p1, p2);
        media.appendChild(pastilla);
        if (lista.swiper) lista.swiper.appendSlide(f); else contenedor(lista).appendChild(f);
        return f;
      };

      // Miniatura de la tote. En el ordenador la hace el propio tema al repintar la tira (la foto está en su lista);
      // si el tema no la ha hecho, se pone aquí
      const ponMini = function (foto) {
        const inner = tira();
        if (!inner || !foto) return;
        if (Array.from(inner.children).some(b => b.__li === foto)) return;
        if (inner.querySelector(':scope > .wk-tote-mini')) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wk-thumbs__item wk-tote-mini';
        b.setAttribute('data-wke', 'promo');
        b.setAttribute('data-wke-tote', '');
        b.setAttribute('aria-label', titulo);
        b.__li = foto;
        const im = document.createElement('img');
        im.src = fotoTote(120);
        im.alt = '';
        im.width = 48;
        im.height = 48;
        b.appendChild(im);
        b.addEventListener('click', () => {
          const lista = foto.closest('.product__media-list');
          if (lista && lista.swiper) { const i = diapositivas(lista).indexOf(foto); if (i >= 0) lista.swiper.slideTo(i); }
          else foto.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        inner.appendChild(b);
      };

      // Pestaña «Regalo» (móvil): va detrás de las del tema y su panel sale justo debajo de la fila
      const ponTab = function () {
        const fila = product.querySelector('.wk-tabs');
        if (!fila || fila.querySelector('.wk-tote-tab')) return;
        const otras = Array.from(fila.querySelectorAll('button[role="tab"]'));
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wk-tote-tab';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('data-wke', 'promo');
        b.setAttribute('data-wke-tote', '');
        b.textContent = cfg.wkeTab || '';
        const panel = document.createElement('div');
        panel.className = 'wk-tote-panel';
        panel.setAttribute('data-wke', 'promo');
        panel.setAttribute('data-wke-tote', '');
        const caja = document.createElement('div');
        caja.className = 'wk-tote-panel__in';
        const im = document.createElement('img');
        im.src = fotoTote(200);
        im.alt = titulo;
        const texto = document.createElement('div');
        const tit = document.createElement('b');
        tit.textContent = titulo;
        const txt = document.createElement('span');
        txt.textContent = cfg.wkeTabTexto || '';
        texto.append(tit, txt);
        caja.append(im, texto);
        panel.appendChild(caja);
        fila.appendChild(b);
        fila.insertAdjacentElement('afterend', panel);
        // Al abrirla se cierran los desplegables; al abrir cualquier otra pestaña, esta se cierra
        b.addEventListener('click', () => {
          product.querySelectorAll('.product__accordion details[open]').forEach(d => { d.open = false; });
          fila.querySelectorAll('button[role="tab"]').forEach(x => {
            const on = x === b;
            x.classList.toggle('on', on);
            x.setAttribute('aria-selected', String(on));
          });
          panel.classList.add('wk-abierto');
        });
        otras.forEach(x => x.addEventListener('click', () => {
          b.classList.remove('on');
          b.setAttribute('aria-selected', 'false');
          panel.classList.remove('wk-abierto');
        }));
      };

      // Línea «+ tote bag de regalo» bajo «Añadir al carrito» y en la barra fija, sin mover el precio.
      // Va en un span propio (.wk-atc-col) que el tema no repinta; si el tema reescribe el botón, se vuelve a poner
      const hazGancho = function () {
        const g = document.createElement('span');
        g.className = 'wk-atc-gift';
        g.setAttribute('data-wke', 'promo');
        g.setAttribute('data-wke-tote', '');
        g.textContent = cfg.wkeBoton || '';
        return g;
      };
      const ponLinea = function () {
        if (!cfg.wkeBoton) return;
        wrap.querySelectorAll('product-form button[name="add"]').forEach(b => {
          if (b.querySelector('.wk-atc-gift')) return;
          let col = b.querySelector(':scope > .wk-atc-col');
          if (!col) {
            const txt = Array.from(b.children).find(c => c.tagName === 'SPAN' && !c.classList.contains('wk-atc-price') && !c.classList.contains('wk-sprout'));
            if (!txt) return;
            col = document.createElement('span');
            col.className = 'wk-atc-col';
            txt.parentNode.insertBefore(col, txt);
            col.appendChild(txt);
          }
          col.appendChild(hazGancho());
        });
        document.querySelectorAll('.wk-sticky-atc__label').forEach(l => {
          if (l.querySelector('.wk-atc-gift')) return;
          let col = l.querySelector(':scope > .wk-atc-col');
          if (!col) {
            const txt = document.createElement('span');
            txt.className = 'wk-atc-txt';
            txt.textContent = l.textContent.trim();
            col = document.createElement('span');
            col.className = 'wk-atc-col';
            l.textContent = '';
            col.appendChild(txt);
            l.appendChild(col);
          }
          col.appendChild(hazGancho());
        });
      };
      // El envoltorio .wk-atc-col se queda: el texto sigue dentro de un span (syncBtn lo necesita)
      const quitaLinea = function () {
        wrap.querySelectorAll('product-form button[name="add"] .wk-atc-gift').forEach(g => g.remove());
        document.querySelectorAll('.wk-sticky-atc__label .wk-atc-gift').forEach(g => g.remove());
      };

      const quitaFotos = function () {
        listas().forEach(lista => {
          const f = fotoDe(lista);
          if (!f) return;
          const i = diapositivas(lista).indexOf(f);
          if (lista.swiper && i >= 0) lista.swiper.removeSlide(i);
          else f.remove();
        });
      };
      const quitaTodo = function () {
        const inner = tira();
        if (inner) {
          Array.from(inner.children).forEach(b => {
            if (b.classList.contains('wk-tote-mini') || (b.__li && b.__li.classList && b.__li.classList.contains('wk-tote-foto'))) b.remove();
          });
        }
        quitaFotos();
        product.querySelectorAll('.wk-tote-tab, .wk-tote-panel').forEach(n => n.remove());
        quitaLinea();
      };

      // Pone lo que falte (foto, miniatura, pestaña y línea); lo que ya está no se toca
      const asegura = function () {
        if (!hay) return;
        const url = fotoTote(1200);
        if (!url) return;
        const pr = principal();
        listas().forEach(lista => ponFoto(lista, url));
        if (pr) ponMini(fotoDe(pr));
        ponTab();
        ponLinea();
      };
      // El tema repinta la galería, la tira y los botones al cambiar de talla o variante: se repasa en el siguiente cuadro
      const repasa = function () {
        if (!hay || turno) return;
        turno = requestAnimationFrame(function () { turno = 0; asegura(); });
      };
      const aplica = function (si) {
        hay = !!si;
        if (!hay) { quitaTodo(); return; }
        asegura();
        if (!vigila) {
          vigila = true;
          new MutationObserver(repasa).observe(wrap, { childList: true, subtree: true });
        }
      };
      const arranca = function () {
        if (W.toteListo) W.toteListo.then(function (t) { aplica(!!(t && t.disponible && !W.sinTote)); });
        document.addEventListener('wke:tote', function (e) { aplica(!!(e.detail && e.detail.hay)); });
      };
      if (W.toteListo) arranca(); else document.addEventListener('DOMContentLoaded', arranca);
    } catch (e) {}
  }
})();
